import type { UUID } from "@/core/types";

export const timelineKeys = {
  base: ["timeline"] as const,
  feed: (patientId: string) => [...timelineKeys.base, patientId, "activity-feed"] as const,
  practiceName: (practiceId: UUID) => [...timelineKeys.base, practiceId, "practice-name"] as const,
} as const;
